import React from "react";

export const CongratulatoryCardContext = React.createContext();